import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
} from "react-router-dom";
import "./App.css";
import TheCameraPage from "./components/TheCameraPage";
import ImagePage from "./components/ImagePage";
import UserProfile from "./components/UserProfile";
import AddToHomeScreenPrompt from "./components/AddToHomeScreenPrompt"; // Ensure this is correctly imported

function App() {
  const navigate = useNavigate();

  const handleCapture = () => {
    navigate("/camera");
  };

  return (
    <div className="app-container">
      <img
        src="/logo-with-text (1).png"
        alt="logo"
        style={{ width: "150px" }}
      />

      <h1 className="static-title">Thank You for Attending!</h1>
      <p className="subtitle">
        We loved having you at our event. Access your pictures captured
        throughout the day in just a few steps.
      </p>
      <button className="capture-button" onClick={handleCapture}>
        Capture Your Face
      </button>
      <p className="description">
        We’ll match your face with your event pictures.
      </p>

      {/* Add the PWA Install Prompt here */}
      <AddToHomeScreenPrompt />
    </div>
  );
}

export default function Main() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/camera" element={<TheCameraPage />} />
        <Route path="/images" element={<ImagePage />} />
        <Route path="/user/:id" element={<UserProfile />} />
      </Routes>
    </Router>
  );
}
